export default "__VITE_PUBLIC_ASSET__732ef817__"